import {VectorItemPanels} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-vector-options/poster-editing-vector-options.types';
import {useGetKeyFromShadowOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromShadowOfActiveItem';
import {useEffect} from 'react';
import {ShadowOrGlowType} from '@postermywall/fabricjs-2';

export function useIsOpenedVectorPanelValid(currentlyOpenedColorPanel: VectorItemPanels, setCurrentlyOpenedPanel: (newVal: VectorItemPanels) => void): void {
  const shadowOrGlowType = useGetKeyFromShadowOfActiveItem('shadowOrGlowType');

  useEffect((): void => {
    if (shadowOrGlowType !== ShadowOrGlowType.CUSTOM_SHADOW && currentlyOpenedColorPanel === VectorItemPanels.CUSTOM_SHADOW) {
      setCurrentlyOpenedPanel(VectorItemPanels.NONE);
    }
  }, [shadowOrGlowType]);
}
